/**
 * @fileoverview Puzzle theme - match various fun emojis.
 */

import { ThemeOptions } from '../../../services/ThemeService.js';
import { EmojiMatchingTheme } from '../../abstract/EmojiMatchingTheme.js';
import { allLabels } from '../../Labels.js';

/**
 * Puzzle theme with simple matching pairs using various emojis.
 */
export class MixTheme extends EmojiMatchingTheme {
    
    constructor(options: ThemeOptions = {}) {
        super('puzzle', 'Puzzle', 
            allLabels.mix, 
        {numPairs: 3, isPremium: false, hasMovement: false, ...options}
        );
    }
    
}
